import { useEffect, useState } from 'react';

const DEBUG_LOADING_DELAY_MS = parseInt(
  process.env.REACT_APP_DEBUG_LOADING_DELAY || '0',
  10
);

/**
 * Delays showing the loading state to avoid flash when loading completes quickly.
 * Returns true only when loading has been true for at least delayMs.
 * Hides immediately when loading becomes false.
 * Set REACT_APP_DEBUG_LOADING_DELAY=3000 in .env.local to keep skeletons visible 3s for testing.
 * @param {boolean} loading - The raw loading state
 * @param {number} [delayMs=250] - Minimum ms before showing loading UI
 * @returns {boolean} - Whether to show the loading indicator
 */
export function useDelayedLoading(loading, delayMs = 250) {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => setShowLoading(true), delayMs);
      return () => clearTimeout(timer);
    }
    if (DEBUG_LOADING_DELAY_MS > 0) {
      const timer = setTimeout(() => setShowLoading(false), DEBUG_LOADING_DELAY_MS);
      return () => clearTimeout(timer);
    }
    setShowLoading(false);
  }, [loading, delayMs]);

  return showLoading;
}
